import { render, staticRenderFns } from "./weekDialog.vue?vue&type=template&id=771cc3c2&scoped=true"
import script from "./weekDialog.vue?vue&type=script&lang=js"
export * from "./weekDialog.vue?vue&type=script&lang=js"
import style0 from "./weekDialog.vue?vue&type=style&index=0&id=771cc3c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771cc3c2",
  null
  
)

export default component.exports